import Swal from 'sweetalert2';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import VideoIcon from '../icons/youtube.svg';

import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';

export default class VideoYoutube extends Plugin {
  static get requires() {
    return [MediaEmbed];
  }

  init() {
    const editor = this.editor;

    editor.ui.componentFactory.add('videoYoutube', (locale) => {
      const view = new ButtonView(locale);

      view.set({
        label: 'Coloque o ID do vídeo no youtube',
        icon: VideoIcon,
        tooltip: true,
      });

      // Callback executed once the image is clicked.
      view.on('execute', async () => {
        const { value: id } = await Swal.fire({
          input: 'text',
          inputPlaceholder: 'Coloque o ID do vídeo no youtube',
        });

        if (id) {
          editor.model.change((writer) => {
            // const url = `https://www.youtube.com/embed/${id}`;

            // const content = `
            // <div class="ck-media__wrapper" data-oembed-url="${url}">
            // </div>`;

            // const viewFragment = editor.data.processor.toView(content);
            // const modelFragment = editor.data.toModel(viewFragment);

            // console.log(modelFragment);

            // editor.model.insertContent(
            //   modelFragment,
            //   editor.model.document.selection
            // );

            const imageElement = writer.createElement('media', {
              url: `https://www.youtube.com/embed/${id}`,
            });

            // Insert the image in the current selection location.
            editor.model.insertContent(
              imageElement,
              editor.model.document.selection
            );
          });
        }
      });

      return view;
    });
  }
}
